import { FormOutlined, StopOutlined } from '@ant-design/icons';
import { Alert, Button, message, Modal } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { updateCycle, updateCycleStatus } from 'services/api/cycles';
import styles from 'styles/components/stopCycleModal.module.scss';
import { CYCLE_STATUS } from 'utils/constants';

const StopCycleModal = ({ cycle, open, onClose, onFinish }) => {
  const [draftLoading, setDraftLoading] = useState(false);
  const [stopNowLoading, setStopNowLoading] = useState(false);
  const updateCycleStatusFunction = (status) => {
    setDraftLoading(true);
    return updateCycleStatus({
      cycleId: cycle._id,
      status: status,
    })
      .then(() => {
        onFinish();
      })
      .catch((e) => {
        console.error(e);
        message.error('Error sending cycle');
      })
      .finally(() => {
        setDraftLoading(false);
      });
  };

  const makeItADraft = () => updateCycleStatusFunction(CYCLE_STATUS.DRAFT);

  const stopNow = () => {
    setStopNowLoading(true);
    updateCycle({
      cycleId: cycle._id,
      deadline: dayjs().format(), //put deadline to now
    })
      .then(() => {
        onFinish();
      })
      .catch((e) => {
        console.error(e);
        message.error('Error stopping cycle');
      })
      .finally(() => {
        setStopNowLoading(false);
      });
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={onFinish}
      title="Are you sure you want to stop the cycle now?"
      footer={null}
      width={600}
    >
      {cycle && (
        <div>
          <div>Be aware that this will override the original deadline:</div>
          <div className={styles.deadline}>
            Deadline: {dayjs(cycle.deadline).format('DD/MM/YYYY')}
          </div>
          <div className={styles.hint}>
            <Alert type="info" showIcon message="If you want to pause collection or edit the cycle, consider putting it back as a draft." />
          </div>

          <div className={styles.footer}>
            <div style={{ flexGrow: 1 }}>
              <Button
                onClick={makeItADraft}
                icon={<FormOutlined />}
                loading={draftLoading}
              >
                Put back as Draft 
              </Button>
            </div>
            <Button onClick={onClose} type="link">
              No, cancel
            </Button>
            <Button
              onClick={stopNow}
              type="primary"
              icon={<StopOutlined />}
              loading={stopNowLoading}
            >
              Yes, Stop now
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default StopCycleModal;
